import { Component, computed, input } from '@angular/core';
import { InfoHoverComponent } from '../../../../../components/info-hover/info-hover.component';
import { RatingIconComponent } from '../../../../../components/rating-icon/rating-icon.component';

@Component({
  selector: 'app-response-score',
  imports: [InfoHoverComponent, RatingIconComponent],
  templateUrl: './response-score.component.html',
  styleUrl: './response-score.component.css',
})
export class ResponseScoreComponent {
  public score = input.required<number>();
  protected rating = computed(() => {
    const s = this.score();
    if (s > 8.76) {
      return { path: 'rating/VeryLikely.png', label: $localize`Very likely`, score: s.toFixed(2) };
    } else if (s > 6.26) {
      return { path: 'rating/SomewhatLikely.png', label: $localize`Somewhat likely`, score: s.toFixed(2) };
    } else if (s > 3.76) {
      return { path: 'rating/Neutral.png', label: $localize`Neutral`, score: s.toFixed(2) };
    } else if (s > 1.26) {
      return {
        path: 'rating/SomewhatUnlikely.png',
        label: $localize`Somewhat unlikely`,
        score: s.toFixed(2),
      };
    } else {
      return { path: 'rating/VeryUnlikely.png', label: $localize`Very unlikely`, score: s.toFixed(2) };
    }
  });
}
